<template>
  <div class="act-table-container">
    <a-table
      :columns="columns"
      :row-key="record => record.id"
      :data-source="data"
      :pagination="paginationConfig"
      :loading="loading"
      :locale="locale"             
      @change="handleTableChange"
      class="modern-table"
      :scroll="{ x: 800 }"
    >
      <template slot="sdate" slot-scope="record">
        <router-link :to="{name:'Act_date',params:{ id: record.id}}" class="date-link">
          <div class="date-button">
            <b-icon icon="calendar3" class="date-icon"></b-icon>
            <span class="date-text">{{ fdateformat(record.sdate) }}</span>
          </div>
        </router-link>                
      </template>
      
      <template slot="actitle" slot-scope="record">
        <router-link
          :to="{
                      name:'Actinfo', 
                      params: { id: record.id}
                      }"
          target="_blank"
          class="title-link"
        >
          <div class="title-content">
            <span class="title-text">{{ record.actitle }}</span>
            <b-icon icon="box-arrow-up-right" class="external-icon"></b-icon>
          </div>
        </router-link>
      </template>
      
      <template slot="states" slot-scope="record">
        <div class="status-badge" :class="getStatusClass(record.states)">
          <span class="status-text">{{ ctypes(record.states) }}</span>
        </div>
      </template>
      
      <template slot="action" slot-scope="record">        
        <div class="action-buttons">
          <a v-if="record.states=='N'" @click="del(record)" href="javascript: void(0)" class="action-btn delete-btn">
            <b-icon icon="trash" class="btn-icon"></b-icon>
            <span class="btn-text">刪除</span>
          </a>
          
          <router-link
            v-if="record.states=='N'"
            :to="{
                  name:'Actedite', 
                  params: { id: record.id, edit:'revise'}
                  }"
            class="action-btn edit-btn"
          >
            <b-icon icon="pencil-square" class="btn-icon"></b-icon>
            <span class="btn-text">編輯</span>
          </router-link>
          
          <a @click="copyAct(record)" href="javascript: void(0)" class="action-btn copy-btn">
            <b-icon icon="files" class="btn-icon"></b-icon>
            <span class="btn-text">複製</span>
          </a>
          
          <a v-if="record.states=='Y' && fdateformat(record.sdate)>fdateformat(currentTime)" @click="del(record)" href="javascript: void(0)" class="action-btn delete-btn">
            <b-icon icon="trash" class="btn-icon"></b-icon>
            <span class="btn-text">刪除</span>
          </a>
        </div>
      </template>
    </a-table>
  </div>
</template>   
<script>
import * as moment from "moment/moment";
import { actService, macService } from "../../../_services";
import { mapState } from "vuex";
import 'moment/locale/zh-tw';

const queryData = params => {
  return actService.FindactpagebystatewithActitle(params);
};

const delData = params => {
  return macService.macDel(params);
}

const copyItem = params => {
  return macService.macCopy(params);
}

const columns = [
  {
    title: "活動日期",
    dataIndex: "",
    width: "15%",
    ellipsis: true,
    scopedSlots: { customRender: "sdate" }
  },
  {
    title: "活動名稱",
    dataIndex: "",
    width: "55%",
    ellipsis: true,
    scopedSlots: { customRender: "actitle" }
  },
  {
    title: "狀態",
    dataIndex: "",
    ellipsis: true,
    scopedSlots: { customRender: "states" },
    width: "10%"
  },
  {
    title: " 編輯 ",
    dataIndex: "",
    key: "id",
    ellipsis: true,
    scopedSlots: { customRender: "action" },
    width: "20%"
  }
];

export default {
  name: "Act_table",
  props: {
    ids: {
      type: String
    },
    items: {
      type: Array
    },
    actName: {
      type: String
    }
  },
  data() {
    return {
      pagination: { defaultPageSize: 10},
      pageSize: 10,
      columns,
      loading: false,
      data: [],
      myPage:1,
      totalRecords: 0,
      currentTime: moment(),
      locale:{
        filterConfirm:'確定',
        filterReset: '重置',
        emptyText: '暫時無任何數據'        
      },
    };
  },
  computed: {
    ...mapState("makeorg", ["defaultval"]),
    paginationConfig() {
      return {
        current: this.myPage,
        pageSize: this.pageSize,
        total: this.totalRecords,
        showSizeChanger: true,
        showQuickJumper: false,
        showTotal: (total, range) => `共 ${total} 筆，顯示 ${range[0]}-${range[1]} 筆`,
        pageSizeOptions: ['5','10', '20', '50']
      };
    }    
  },
  mounted() {
    //console.log("mounted-reload");
    const queryTableState = JSON.parse(window.sessionStorage.getItem('queryTableState'));
    if (queryTableState) {
      this.myPage = queryTableState.page || 1;
      this.pageSize = queryTableState.pageSize || 10;
      this.reloadByPage();
    } else {
      this.reload();
    }
  },
  watch: {
    ids() {
      //console.log("watch-reload");
      this.reload();
    },
    actName() {
      //console.log("watch-reload");
      this.reload();
    },    
    defaultval() {
      //console.log("watch-defaultval");
      this.reload();
    }
  },
  methods: {
    getStatusClass(status) {
      const statusClasses = {
        'N': 'status-draft',
        'I': 'status-review',
        'Y': 'status-published',
        'F': 'status-finished',
        'D': 'status-offline'
      };
      return statusClasses[status] || 'status-default';
    },

    handleTableChange(pagination, filters, sorter) {
      //console.log('handleTableChange called with:', pagination); // 用於調試
      
      // 更新當前頁面和頁面大小
      this.myPage = pagination.current;
      this.pageSize = pagination.pageSize;
      
      // 呼叫 fetch 方法獲取新數據
      this.fetch({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        uid: this.defaultval.id,
        state: this.ids,
        actitle: this.actName,
        size: pagination.pageSize,        
        ...filters
      });
      
      // 儲存當前頁面狀態到 sessionStorage
      let queryTableState = {
        page: pagination.current,
        pageSize: pagination.pageSize
      }
      window.sessionStorage.setItem('queryTableState', JSON.stringify(queryTableState));
    },

    fetch(params = {}) {
      //console.log('fetch called with params:', params); // 用於調試
      this.loading = true;
      queryData({
        ...params
      }).then(({ data }) => {
        //console.log('API response:', data); // 用於調試
        
        // 更新數據和總數
        this.data = data.results;
        this.totalRecords = data.info.totail;
        this.loading = false;
        
        // 確保當前頁面狀態正確
        if (params.page) {
          this.myPage = params.page;
        }
        if (params.results) {
          this.pageSize = params.results;
        }
      }).catch(error => {
        console.error('API error:', error);
        this.loading = false;
      });
    },

    copyAct(items){
      const self = this;
      this.$confirm({
        title:
          "活動複製後, 請至草稿編輯送審 ",
        content: "活動名稱 : " + items.actitle,
        okText: "Yes",
        okType: "primary",
        cancelText: "No",
        zIndex: 9999,
        async onOk() {
          await self.copyMyAct(items.id);
        },
        onCancel() {
          console.log("Cancel");
        }
      });      
    },

    async copyMyAct(id) {
      this.loading = true;
      let rsults = await this.CopyMyAct({id})  
      setTimeout(() => {
        if(rsults.data==null || rsults.data==''){
          this.reload();
        }  
      }, 1600);

    },
    
    async CopyMyAct(params={}){
     return await copyItem({
        ...params,
      }).then(({ data }) => {  
        let obj = data;      
        return obj
      });
    },     

    del(items){
      const self = this;
      this.$confirm({
        title:
          "您確定刪除該活動?",
        content: "活動名稱 : " + items.actitle,
        okText: "Yes",
        okType: "danger",
        cancelText: "No",
        zIndex: 9999,
        async onOk() {
          await self.removem(items.id);
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    },   
    
    async removem(id) {
      this.loading = true;
      let rsults = await this.updata({id})  
      setTimeout(() => {
        if(rsults.data==null || rsults.data==''){
          this.reloadByPage();
        }   
      }, 1600);
      
    },    

    async updata(params={}){
     return await delData({
        ...params,
      }).then(({ data }) => {  
        let obj = data;      
        return obj
      });
    },    

    fdateformat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
    ctypes(val) {
      //return狀態 N草稿, I審核中, R發佈中, F結束, D下架
      let tmp = "";
      val == "N" ? (tmp = "草稿") : "";
      val == "I" ? (tmp = "審核中") : "";
      val == "Y" ? (tmp = "發佈中") : "";
      val == "F" ? (tmp = "結束") : "";
      val == "D" ? (tmp = "下架") : "";
      return tmp;
    },

    reload() {
      this.fetch({
        results: this.pageSize,
        page: 1,
        size: this.pageSize,
        uid: this.defaultval.id,
        state: this.ids,
        actitle: this.actName,
      });
    },
    reloadByPage(){
      this.fetch({
        results: this.pageSize,
        page: this.myPage,
        size: this.pageSize,
        uid: this.defaultval.id,
        state: this.ids,
        actitle: this.actName,
      });
    },
  },
};
</script>

<style scoped>
/* 主容器 */
.act-table-container {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: 1px solid #f0f2f5;
}

/* 日期連結樣式 */
.date-link {
  text-decoration: none;
  display: inline-block;
}

.date-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 8px;
  transition: all 0.2s ease;
  border: 1px solid #e2e8f0;
}

.date-button:hover {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.2);
}

.date-icon {
  font-size: 14px;
  color: #64748b;
  transition: color 0.2s ease;
}

.date-button:hover .date-icon {
  color: white;
}

.date-text {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  transition: color 0.2s ease;
}

.date-button:hover .date-text {
  color: white;
}

/* 標題連結樣式 */
.title-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.title-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  transition: all 0.2s ease;
}

.title-text {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  line-height: 1.4;
  flex: 1;
  margin-right: 8px;
}

.external-icon {
  font-size: 12px;
  color: #94a3b8;
  opacity: 0;
  transition: all 0.2s ease;
}

.title-link:hover .title-content {
  color: #3b82f6;
}

.title-link:hover .external-icon {
  opacity: 1;
  color: #3b82f6;
}

/* 狀態標籤樣式 */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  min-width: 60px;
  justify-content: center;
}

.status-draft {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.status-review {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
}

.status-published {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}

.status-finished {
  background: #e5e7eb;
  color: #374151;
  border: 1px solid #d1d5db;
}

.status-offline {
  background: #fee2e2;
  color: #dc2626;
  border: 1px solid #fca5a5;
}

.status-text {
  font-weight: 600;
}

/* 操作按鈕樣式 */
.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 6px;
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
  border: 1px solid;
  white-space: nowrap;
}

.btn-icon {
  font-size: 12px;
}

.btn-text {
  font-size: 12px;
}

.edit-btn {
  background: #dbeafe;
  color: #1d4ed8;
  border-color: #bfdbfe;
}

.edit-btn:hover {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.copy-btn {
  background: #ecfdf5;
  color: #059669;
  border-color: #a7f3d0;
}

.copy-btn:hover {
  background: #10b981;
  color: white;
  border-color: #10b981;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
}

.delete-btn {
  background: #fef2f2;
  color: #dc2626;
  border-color: #fecaca;
}

.delete-btn:hover {
  background: #ef4444;
  color: white;
  border-color: #ef4444;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.2);
}

/* 響應式設計 */
@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 4px;
    align-items: stretch;
  }
  
  .action-btn {
    justify-content: center;
    min-width: auto;
  }
  
  .date-button {
    padding: 4px 8px;
  }
  
  .date-text {
    font-size: 12px;
  }
  
  .title-text {
    font-size: 13px;
  }
}
</style>

<style>
/* 全域表格樣式 */
.modern-table .ant-table {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.modern-table .ant-table-thead > tr > th {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 2px solid #e2e8f0;
  color: #374151;
  font-weight: 600;
  font-size: 13px;
  padding: 16px 12px;
  text-align: left;
}

.modern-table .ant-table-tbody > tr > td {
  border-bottom: 1px solid #f1f5f9;
  padding: 12px;
  font-size: 13px;
  vertical-align: middle;
}

.modern-table .ant-table-tbody > tr:hover > td {
  background: #f8fafc;
  transition: background 0.2s ease;
}

.modern-table .ant-table-tbody > tr:last-child > td {
  border-bottom: none;
}

.modern-table .ant-pagination {
  padding: 16px;
  background: #f8fafc;
  border-top: 1px solid #f1f5f9;
  margin: 0;
}

.modern-table .ant-pagination-item {
  border: 1px solid #e2e8f0;
  background: #ffffff;
}

.modern-table .ant-pagination-item:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

.modern-table .ant-pagination-item-active {
  background: #3b82f6;
  border-color: #3b82f6;
}

.modern-table .ant-pagination-item-active a {
  color: white;
}

.modern-table .ant-spin-container {
  min-height: 200px;
}

.modern-table .ant-empty {
  padding: 40px 20px;
}

.modern-table .ant-empty-description {
  color: #6b7280;
  font-size: 14px;
}

/* 載入動畫 */
.modern-table .ant-spin-spinning {
  background: rgba(255, 255, 255, 0.8);
}

.modern-table .ant-spin-dot {
  font-size: 20px;
}

.modern-table .ant-spin-dot-item {
  background-color: #3b82f6;
}

/* 移除舊樣式 */
.hidden_cssd {
  border-top: 1px solid #f1f1f0;
  border-bottom: 3px solid #ebebe8;
  border-style: dotted;
}
</style>